package kz.dentalcrm.app.data

import kz.dentalcrm.app.data.network.TreatmentApi
import kz.dentalcrm.app.data.network.request_model.StoreTreatmentRequest
import kz.dentalcrm.app.data.network.response_model.protocol_templates.ProtocolTemplate
import kz.dentalcrm.app.data.network.response_model.protocol_templates.TemplateItem
import kz.dentalcrm.app.data.network.response_model.protocol_templates.TreatmentDetailResponseItem
import kz.dentalcrm.app.domain.TreatmentRepository
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.core.utils.map

class TreatmentRepositoryImpl(
    private val treatmentApi: TreatmentApi
) : TreatmentRepository {
    override suspend fun getTreatments(page: Int, search: String): Result<List<ProtocolTemplate>?> {
        return treatmentApi.getTreatments(page = page, search = search).map { it?.data?.data }
    }

    override suspend fun getTreatmentDetail(
        id: String
    ): Result<List<TreatmentDetailResponseItem>?> {
        return treatmentApi.getTreatmentDetails(id = id)
    }

    override suspend fun addEditTreatment(name: String, code: String, id: Int?): Result<Any?> {
        return treatmentApi.addTreatment(
            name = name,
            code = code,
            id = id
        )
    }

    override suspend fun deleteTreatment(id: Int): Result<Any?> {
        return treatmentApi.deleteTreatment(id = id)
    }

    override suspend fun updateTreatmentDetails(templateId: Int, items: List<TreatmentDetailResponseItem>): Result<Any?> {
        return treatmentApi.updateTreatmentDetails(templateId = templateId, items = items)
    }

    override suspend fun getTemplates(): Result<List<TemplateItem>?> {
        return treatmentApi.getTemplates()
    }

    override suspend fun storeTreatment(request: StoreTreatmentRequest): Result<Any?> {
        return treatmentApi.storeTreatment(request)
    }
}